import { render } from "./BaseAccountingForm.vue?vue&type=template&id=7a345f71&scoped=true"
import script from "./BaseAccountingForm.vue?vue&type=script&lang=js"
export * from "./BaseAccountingForm.vue?vue&type=script&lang=js"

import "./BaseAccountingForm.vue?vue&type=style&index=0&id=7a345f71&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7a345f71"

export default script